<div class="header-container" [class.non-production]="!!build">

  <div style="display: flex;">
    <a routerLink="/home" class="brand" data-id="header-logo-href">
      <img src="assets/images/v2/logo-with-text.svg"
           height="30" alt="edgeless-icon" class="image desktop">
      <img src="assets/images/logo-icon.svg"
           height="30" alt="edgeless-icon" class="image mobile">
      <span class="santa-hat" *ngIf="santaHat"></span>
      <span class="build" *ngIf="build">{{ build }}</span>
    </a>
  </div>

  <div class="header-links-wrap --mobile">
    <ng-container *ngIf="auth.isAuthenticated()">
      <app-balance-selector></app-balance-selector>
    </ng-container>
    <ng-container *ngIf="!auth.isAuthenticated()">
        <a href="/" class="support" (click)="intercom.show();$event.preventDefault();trackOpenSupport();"
           data-id="header-support-button">
                <span class="icon-wrap"><i class="fal fa-question"
                                           [class.pulse]="!(intercom.unreadCount > 0)"></i></span>
          Support
        </a>
        <a [routerLink]="['/', { outlets: { modal: 'login' } } ]">
          <app-form-button href="#" class="medium no-width" data-id="header-login-button">Log In</app-form-button>
        </a>
        <div class="space-between-buttons"></div>
        <a [routerLink]="['/', {outlets: { modal: 'signup' } } ]" (click)="trackSignUpOpen()">
          <app-form-button class="medium primary no-width" data-id="header-signup-button">Sign Up
          </app-form-button>
        </a>
      </ng-container>
  </div>

  <div class="header-links-wrap --desktop">
    <app-jackpot-header-new *ngIf="showJackpot"></app-jackpot-header-new>
    <ng-container *ngIf="!auth.isAuthenticated()">
      <a href="/" class="support" (click)="intercom.show();$event.preventDefault();trackOpenSupport();"
         data-id="header-support-button">
        <span class="icon-wrap"><i class="fal fa-question" [class.pulse]="!(intercom.unreadCount > 0)"></i></span>
        Support
      </a>
      <a [routerLink]="['/', { outlets: { modal: 'login' } } ]">
        <app-form-button href="#" class="medium no-width" data-id="header-login-button">Log In</app-form-button>
      </a>
      <div class="space-between-buttons"></div>
      <a [routerLink]="['/', {outlets: { modal: 'signup' } } ]" (click)="trackSignUpOpen()">
        <app-form-button class="medium primary no-width" data-id="header-signup-button">Sign Up
        </app-form-button>
      </a>
    </ng-container>
    <ng-container *ngIf="auth.isAuthenticated()">
      <app-chest-wager *ngIf="showWagerProgress"></app-chest-wager>
      <!--<div class="space-between-buttons"></div>-->
      <a href="/" class="support" (click)="setAccountDropdown(false, $event);intercom.show();"
         data-id="header-support-button">
        <span class="icon-wrap"><i class="fal fa-question" [class.pulse]="!(intercom.unreadCount > 0)"></i></span>
        Support
      </a>

      <div class="header-icons-wrap account-icon">
        <a [routerLink]="['/account/bonus']" class="account" data-id="header-bonus-button">
          <div class="icon-wrap notifications" style="margin-right: 10px;">
            <i class="fal fa-gift"></i>
            <span class="badge"
                  [class.--pulse]="notificationsBonusCounter > 0"
                  *ngIf="notificationsBonusCounter > 0">
                  {{ notificationsBonusCounter }}
              </span>
          </div>
          Bonus
        </a>
      </div>

      <div class="header-icons-wrap account-icon" (mouseenter)="accountDropdown=true"
           (mouseleave)="accountDropdown=false">
        <a href="#" [routerLink]="'/account/games-history'" class="account" (click)="$event.preventDefault()" data-id="header-account-button">
          <div class="icon-wrap notifications" style="margin-right: 10px;">
            <i class="fal fa-user"></i>
          </div>
          Account
        </a>
        <div class="dropdown-list" [@dropdown]="'show'" *ngIf="accountDropdown">
          <div class="dropdown-inner">
            <ng-container *ngFor="let tab of tabs">
              <a *ngIf="tab.desktopDropdown" [routerLink]="tab.url" class="dropdown-link"
                 (click)="trackAccountTabOpen(tab.id);setAccountDropdown(false, $event);" data-id="header-tab-{{ tab.id }}">
                <div class="icon dark-icon-bg">
                  <i class="fal {{tab.icon}}"></i>
                </div>
                <div class="dropdown-link-text">{{tab.title}}</div>
                <ng-container *ngIf="tab.notificationCount > 0">
                  <div class="event-count" [class.--pulse]="tab.notificationCount > 0">
                    <div class="counter">
                      {{ tab.notificationCount }}
                    </div>
                  </div>
                </ng-container>
              </a>
            </ng-container>
            <a class="dropdown-link" (click)="logout()">
              <div class="icon dark-icon-bg">
                <i class="fal fa-sign-out"></i>
              </div>
              <div class="dropdown-link-text">Logout</div>
            </a>
          </div>
        </div>
      </div>

      <div class="header-icons-wrap account-icon" (mouseenter)="notificationsDropdown=true"
           (mouseleave)="notificationsDropdown=false">
        <a href="#" class="account" (click)="$event.preventDefault()">
          <div class="icon-wrap notifications">
            <i class="fal fa-bell"></i>
            <span class="badge"
                  [class.--pulse]="notificationsCounter"
                  *ngIf="notificationsCounter">
                      {{ notificationsCounter }}
                    </span>
          </div>
        </a>
        <div class="dropdown-list" [@dropdown]="'show'" *ngIf="notificationsDropdown">
          <div class="dropdown-inner notification-dropdown">
            <a href="#" class="dropdown-link"
               (click)="$event.preventDefault(); notificationMark(notification._id)"
               *ngFor="let notification of notifications">
              <div class="notification-dot" [class.seen]="notification.seenAt"></div>
              <div class="dropdown-link-text">{{ notification.text }}</div>
            </a>
            <a href="#" class="dropdown-link" (click)="$event.preventDefault()"
               *ngIf="notifications.length == 0">
              <div class="dropdown-link-text">No notifications yet</div>
            </a>
          </div>
        </div>
      </div>

      <div class="header-icons-wrap account-icon" (mouseenter)="balanceDropdown=true" (mouseleave)="balanceDropdown=false">

        <app-form-button class="medium no-width balance-btn" data-id="header-balance-button">
          <div class="balance-current">
            <img src="/assets/images/currency/{{ balance.getCurrency().toString().toLowerCase() }}.svg" height="25" alt="" class="balance-chip">
            <div class="balance-amount">{{ balance.getCurrentBalance() | crypto : balance.getCurrency() : 'symbol' : true : true }}</div>
            <div class="balance-dollar" *ngIf="balance.getCurrency() !== 'usd' && balance.getCurrency() !== 'usdt20' && balance.getCurrency() !== 'dai'">({{ balance.getCurrentUsdBalance() | currency: 'USD' }})</div>
            <!--<div class="balance-currency">{{ balance.renderCurrency(balance.getCurrentBalance()) }}</div>-->
          </div>
          <div class="nav-link-drop"><i class="fal fa-chevron-down"></i></div>
        </app-form-button>

        <div class="dropdown-list" [@dropdown]="'show'" *ngIf="balanceDropdown">
          <div class="dropdown-inner balance-dropdown">

            <span *ngFor="let item of currencyList" (click)="changeCurrency(item)" class="currency-select-item">
              <img src="/assets/images/currency/{{ item }}.svg"
                   height="25"
                   alt="{{ item }}"
                   class="balance-chip-2">
              <span class="nav-balance">
                <span>{{ balance.getBalance(item) | crypto: item : 'symbol' : true }}</span>
                <span class="currency" [ngClass]="item">{{ item.toString().toUpperCase() }}</span>
              </span>
            </span>

            <ng-container *ngFor="let tab of tabs">
              <a *ngIf="tab.balanceDropdown" [routerLink]="tab.url" class="dropdown-link"
                 (click)="trackAccountTabOpen(tab.id);setAccountDropdown(false, $event);" data-id="header-tab-{{ tab.id }}">
                <div class="icon dark-icon-bg">
                  <i class="fal {{tab.icon}}"></i>
                </div>
                <div class="dropdown-link-text">{{tab.title}}</div>
                <ng-container *ngIf="tab.notificationCount > 0">
                  <div class="event-count" [class.--pulse]="tab.notificationCount > 0">
                    <div class="counter">
                      {{ tab.notificationCount }}
                    </div>
                  </div>
                </ng-container>
              </a>
            </ng-container>

            <!--<div class="separation-line"></div>-->
            <div class="hovering-part"></div>
            <div class="nav-pointer"></div>
            <!--<div class="separation-line"></div>-->
          </div>
        </div>
      </div>

      <div class="space-between-buttons"></div>

      <ng-container *ngIf="auth.userInfo">
        <a *ngIf="!auth.userInfo.emailVerified" [routerLink]="['/', {outlets: { modal: 'signup-verify' } } ]">
          <app-form-button class="medium primary no-width" data-id="header-verify-button">Verify email
          </app-form-button>
        </a>
        <a *ngIf="auth.userInfo.emailVerified" [routerLink]="['/', {outlets: { modal: 'deposit' } } ]"
           (click)="trackDepositOpen()">
          <app-form-button class="medium primary no-width" data-id="header-deposit-button">Deposit
          </app-form-button>
        </a>
      </ng-container>
    </ng-container>
  </div>

  <div class="header-icons-wrap hamburger-icon-wrap" *ngIf="auth.isAuthenticated()">
    <div class="icon hamburger-icon" (click)="toggleAccountDropdown($event)">
      <i class="fal fa-bars"></i>
      <span class="badge" [class.--pulse]="notificationPulse || notificationsBonusCounter"
            *ngIf="notificationsCounter || notificationsBonusCounter">
            {{ notificationsCounter + notificationsBonusCounter }}
          </span>
    </div>
    <div class="mobile-menu-list" [class.--opened]="accountDropdown">
      <div class="mobile-menu-wrap">
        <a routerLink="/home" class="brand">
          <img src="/assets/images/Edgeless-Logo-Icon-White.svg" height="35" alt="" class="image">
          <span class="santa-hat" *ngIf="santaHat"></span>
        </a>

        <div class="balance-btn mobile header-icons-wrap account-icon mobile-balance-switcher">

          <app-form-button class="medium no-width balance-btn" data-id="header-balance-button" (click)="balanceDropdown = !balanceDropdown">
            <div class="balance-current">
              <img src="/assets/images/currency/{{ balance.getCurrency().toString().toLowerCase() }}.svg" height="25" alt="" class="balance-chip">
              <div class="balance-amount">{{ balance.getCurrentBalance() | crypto : balance.getCurrency() : true : true : true }}</div>
            </div>
            <div class="nav-link-drop"><i class="fal fa-chevron-down"></i></div>
          </app-form-button>

          <div class="dropdown-list" [@dropdown]="'show'" *ngIf="balanceDropdown">
            <div class="dropdown-inner balance-dropdown">

            <span *ngFor="let item of currencyList" (click)="changeCurrency(item)" class="currency-select-item">
              <img src="/assets/images/currency/{{ item }}.svg"
                   height="25"
                   alt="{{ item }}"
                   class="balance-chip-2">
              <span class="nav-balance">
                <span>{{ balance.getBalance(item) | crypto: item : true : true }}</span>
                <span class="currency" [ngClass]="item">{{ item.toString().toUpperCase() }}</span>
              </span>
            </span>

              <ng-container *ngFor="let tab of tabs">
                <a *ngIf="tab.balanceDropdown" [routerLink]="tab.url" class="dropdown-link"
                   (click)="trackAccountTabOpen(tab.id);setAccountDropdown(false, $event);" data-id="header-tab-{{ tab.id }}">
                  <div class="icon dark-icon-bg">
                    <i class="fal {{tab.icon}}"></i>
                  </div>
                  <div class="dropdown-link-text">{{tab.title}}</div>
                  <ng-container *ngIf="tab.notificationCount > 0">
                    <div class="event-count" [class.--pulse]="tab.notificationCount > 0">
                      <div class="counter">
                        {{ tab.notificationCount }}
                      </div>
                    </div>
                  </ng-container>
                </a>
              </ng-container>

              <!--<div class="separation-line"></div>-->
              <div class="hovering-part"></div>
              <!--<div class="separation-line"></div>-->
            </div>
          </div>
        </div>

      <div class="header-icons-wrap hamburger-icon-wrap" (click)="toggleAccountDropdown($event);">
          <div class="icon hamburger-icon">
            <i class="fal fa-times" style="margin-left: 10px;"></i>
          </div>
      </div>
  </div>

      <a routerLink="/jackpot" (click)="setAccountDropdown(false, $event);">
        <app-chest-wager-mobile *ngIf="showWagerProgress"></app-chest-wager-mobile>
      </a>

      <div class="dropdown-link"
           (click)="setAccountDropdown(false, $event);intercom.show();trackOpenSupport();$event.preventDefault()">
        <div class="icon dark-icon-bg" [class.pulse]="!(intercom.unreadCount > 0)">
          <i class="fal fa-question"></i>
        </div>
        <div class="dropdown-link-text">Support</div>
      </div>
      <div class="dropdown-link" (click)="showNotifications()">
        <div class="icon dark-icon-bg">
          <i class="fal fa-bell"></i>
        </div>
        <div class="dropdown-link-text">Notifications</div>
        <ng-container *ngIf="notificationsCounter">
          <div class="event-count" [class.--pulse]="notificationsCounter > 0">
            <div class="counter">
              {{ notificationsCounter }}
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *ngFor="let tab of tabs" >
        <a *ngIf="tab.mobileDropdown" [routerLink]="tab.url" class="dropdown-link"
           (click)="toggleAccountDropdown($event);">
          <div class="icon dark-icon-bg">
            <i class="fal {{ tab.icon }}"></i>
          </div>
          <div class="dropdown-link-text">{{ tab.title }}</div>
          <ng-container *ngIf="tab.notificationCount > 0">
            <div class="event-count" [class.--pulse]="tab.notificationCount > 0">
              <div class="counter">
                {{ tab.notificationCount }}
              </div>
            </div>
          </ng-container>
        </a>
      </ng-container>

      <div class="mobile-menu-expand">
        <div class="space-between-buttons"></div>
        <app-form-button [routerLink]="['/', {outlets: { modal: 'deposit' } } ]" class="primary width-100">Deposit
        </app-form-button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/header-navigation/header-navigation.template.html